import { Button, Popconfirm, message } from 'antd'
import React from 'react'
import API from '../../../utils/api'
import { IMAGEAPI } from '../../constants/APIKEYS'
import { useToken } from '../../hooks'

const ScreenShot = ({ data, setEdit }: any) => {
	const { data: token } = useToken()

	return (
		<>
			<Button
				onClick={() => {
					API.get(
						'/admin/sc?id=' + data?.id,
						token + '',
						'',
						false,
						IMAGEAPI
					).then(res => {
						if (res?.result?.success) {
							setEdit(res?.result?.result)
						}
					})
				}}
				style={{ marginRight: 5 }}
				type="primary"
				size="small">
				보기
			</Button>
			<Popconfirm
				title="삭제하시겠습니까?"
				okText="Yes"
				cancelText="No"
				onConfirm={() => {
					API.send(
						'DELETE',
						'/admin/sc',
						token + '',
						{
							id: data?.id,
						},
						false
					).then(res => {
						if (res?.result?.success) {
							message.success('삭제되었습니다.')
						}
					})
				}}>
				<Button size="small">X</Button>
			</Popconfirm>
		</>
	)
}

export default React.memo(ScreenShot)
